import * as React from "react";
const SvgTenant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="tenant_svg__svg-icon"
    style={{
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden",
    }}
    viewBox="0 0 1024 1024"
    data-icon="1"
    {...props}
  >
    <path
      fill="#333"
      d="M896 192a128 128 0 0 1 128 128v512a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V320a128 128 0 0 1 128-128zm0 64H256a64 64 0 0 0-64 64v512l.448 7.488A64 64 0 0 0 256 896h640l7.488-.448A64 64 0 0 0 960 832V320l-.448-7.488A64 64 0 0 0 896 256zM774.144 576C785.28 576 800 582.912 800 593.28v163.648C798.08 782.72 779.52 800 751.68 800H630.848c-11.2 0-18.56-6.912-18.56-17.28v-80.96c0-12.032-19.52-18.048-36.288-18.048-16.704 0-40 4.288-40 18.048v81.024c0 10.304-7.424 17.216-18.56 17.216H400.32c-27.84 0-48.32-18.944-48.32-43.072V593.216C352 582.912 367.488 576 378.624 576s26.24 6.912 26.24 17.28v151.488c0 5.12 3.712 8.576 11.136 8.576h71.68V701.76c0-40.384 52.992-64 88.32-64 35.328 0 86.848 23.616 86.848 64v51.584h76.16c5.568 0 9.28 0 9.28-10.304V593.28c0-10.368 14.72-17.28 25.856-17.28zM800 64a32 32 0 1 1 0 64H128a64 64 0 0 0-64 64v544a32 32 0 1 1-64 0V192A128 128 0 0 1 128 64zM609.856 331.136l215.68 177.728c7.296 5.504 7.296 31.68 0 39.04-7.296 7.424-32.832 7.424-40.128 0L587.904 385.536a23.168 23.168 0 0 0-21.952 0L369.728 552.704c-3.648 3.712-7.296 3.712-11.008 3.712-5.44 0-24.768-2.944-28.48-8.448-7.296-7.424-11.072-31.744-3.776-37.312l215.68-179.52c20.16-14.848 49.408-14.848 67.712 0z"
    />
  </svg>
);
export default SvgTenant;
